// Copy for the "Preserving More Than Words" band — screenshot-matched, same
// pattern as highlightsConfig's MAP_COPY and aiPoweredConfig's AI_POWERED_COPY:
// kept in one exported constant so the text has a single place to edit
// instead of being buried in JSX.
export const PRESERVING_WORDS_COPY = {
  title: 'Preserving More Than Words',
  body: 'Many African languages are at risk of disappearing. ZeroUp Reads creates books children can read, enjoy, and share—helping to protect our languages, stories, and cultural heritage while unlocking knowledge for the future.',
};
